import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { Pebble, PebbleText } from "../JobDetailDialog";
import JobDetailTitle from "./JobDetailTitle";
export const PebbleStyle = {
  color: "black",
  border: "1px solid lightgray",
  cursor: "pointer"
};
function JobSkillsRequired({ jobSkills, hiddenSkills, showHiddenSkills, setShowHiddenSkills }) {
  return (
    <Box>
      <JobDetailTitle>Skills Required</JobDetailTitle>
      <Grid container display={"flex"} gap={2} alignItems={"center"}>
        {jobSkills.length === 0 && "No skills specified"}
        {jobSkills.length > 0 &&
          jobSkills.slice(0, 10).map((benefit) => (
            <Pebble
              key={benefit}
              sx={{
                ...PebbleStyle,
                textAlign: "center"
              }}
            >
              <PebbleText>{benefit}</PebbleText>
            </Pebble>
          ))}
        {showHiddenSkills &&
          hiddenSkills.map((skill) => (
            <Pebble
              key={skill}
              sx={{
                ...PebbleStyle,
                textAlign: "center"
              }}
            >
              <PebbleText>{skill}</PebbleText>
            </Pebble>
          ))}
        {jobSkills.length > 10 && (
          <Pebble
            onClick={() => setShowHiddenSkills(true)}
            sx={{
              backgroundColor: "#2b324c",
              color: "white",
              cursor: "pointer",
              ":hover": { backgroundColor: "#1a1e36" },
              transition: "background .5s, color .5s",
              display: `${showHiddenSkills ? "none" : "flex"}`,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <PebbleText>{`+${hiddenSkills.length} More`}</PebbleText>
          </Pebble>
        )}
      </Grid>
    </Box>
  );
}

export default JobSkillsRequired;
